import { hooks, Divider, Flex, Text } from '@bitrise/bitkit';
import React, { FunctionComponent } from 'react';
import Number from './Number';

const { useMediaQuery } = hooks;

const GuideStep: FunctionComponent<{ heading: string; number: string }> = ({
  children,
  heading,
  number,
}) => {
  const isLargeViewport = useMediaQuery(['47.5rem'])('47.5rem');

  return (
    <>
      <Flex
        direction={isLargeViewport ? 'horizontal' : 'vertical'}
        gap="x16"
        paddingHorizontal="x10"
      >
        <Flex alignChildren="middle" direction="horizontal">
          <Number>{number}</Number>
        </Flex>

        <Flex direction="vertical" gap="x3" grow initial="none">
          <Text config="5" margin="x1" textColor="grape-5">
            {heading}
          </Text>
          {children}
        </Flex>
      </Flex>

      <Divider color="gray-3" margin="x10" width="1px" />
    </>
  );
};

export default GuideStep;
